import axios from 'axios';
import config from '@/config/app.config';
import { removeVuexORMFlags } from '@/utils/helpers';

const http = axios.create({
  baseURL: config.api_url,
});

http.interceptors.request.use((request) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

// The app fires several requests in parallel on boot, so an expired token
// produces a burst of 401s. Redirecting on each one navigates repeatedly and
// aborts the sibling requests mid-body, which the server sees as a storm of
// "request aborted" errors. Send the user to the login page at most once.
let redirectingToLogin = false;

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_username');

      const loginPath = `${config.base_url || '/'}login`.replace(/\/{2,}/g, '/');
      if (!redirectingToLogin && window.location.pathname !== loginPath) {
        redirectingToLogin = true;
        window.location.href = loginPath;
      }
    }
    if (!error.response) {
      error.message = error.message || 'Network error. Please check your connection.';
    }
    return Promise.reject(error);
  },
);

class HttpAdapter {
  async get(uri) {
    const res = await http.get(`/api/${uri}`);
    return res.data;
  }

  async post(uri, data) {
    removeVuexORMFlags(data);
    const res = await http.post(`/api/${uri}`, data);
    return res.data;
  }

  async patch(uri, data) {
    removeVuexORMFlags(data);
    const res = await http.patch(`/api/${uri}`, data);
    return res.data;
  }

  async put(uri, data) {
    const res = await http.put(`/api/${uri}`, data);
    return res.data;
  }

  async delete(uri) {
    const res = await http.delete(`/api/${uri}`);
    return res.data;
  }
}

export default new HttpAdapter();
